import { useState } from "react";
import { feedApi } from "../api/feedApi";
import { reportApi } from "../api/reportApi";
import { toast } from "react-toastify";

export function useReport({ onReported }) {
    const [showModal, setShowModal] = useState(false);
    const [step, setStep] = useState(1);
    const [target, setTarget] = useState(null);
    const [reason, setReason] = useState(null);
    const [subReason, setSubReason] = useState(null);
    const [loading, setLoading] = useState(false);

    // OPEN REPORT FOR ANYTHING
    const openReport = ({ id, type }) => {
        setTarget({ id, type });
        setReason(null);
        setSubReason(null);
        setStep(1);
        setShowModal(true);
    };

    const submitReport = async () => {
        if (!target || !reason || !subReason) return;

        try {
            setLoading(true);
            console.log(target.id, target.type, `${reason} - ${subReason}` )

            await reportApi.report({
                targetId: target.id,
                targetType: target.type, // post | comment | reply
                reason: `${reason} - ${subReason}`,
            });

            toast.success("Thanks for reporting. We'll review it.");

            onReported?.(target); // optional UI update
            setShowModal(false);
        } catch (err) {
            const errorMessage =
                err?.response?.data?.error ||
                err?.response?.data?.message ||
                "Failed to report";

            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return {
        // state
        showModal,
        step,
        reason,
        subReason,
        loading,

        // setters
        setStep,
        setReason,
        setSubReason,
        setShowModal,

        // actions
        openReport,
        submitReport,
    };
}
